import React from "react";
import { DateTime } from "luxon";
import { publicLinks } from "../data/dummyData";
import {
  SlSocialInstagram,
  SlSocialLinkedin,
  SlSocialYoutube,
  SlSocialReddit,
} from "react-icons/sl";
import { RiTwitterXFill } from "react-icons/ri";

import { HashLink } from "react-router-hash-link";

const dt = DateTime.local();

const Footer = () => {
  const normalLink =
    "flex justify-center p-3 align-center rounded-lg text-lg text-white hover:text-black hover:bg-light-gray";

  return (
    <div id="footer" className="bg-snappily-orange w-full">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-10 w-full text-center pt-14 px-10">
        {publicLinks.map((item, index) => {
          return (
            <HashLink
              to={`${item.target}`}
              key={item.id}
              className={normalLink}
            >
              {item.name.replace(/-/g, " ").toUpperCase()}
            </HashLink>
          );
        })}
      </div>
      <div className="flex justify-center text-5xl gap-x-5 sm:gap-x-10 mt-10">
        <a
          href="https://www.instagram.com/SnappilyApp"
          target="_blank"
          rel="noopener noreferrer"
        >
          <SlSocialInstagram className="hover:text-white cursor-pointer" />
        </a>
        <a
          href="https://www.linkedin.com/company/snappily-inc"
          target="_blank"
          rel="noopener noreferrer"
        >
          <SlSocialLinkedin className="hover:text-white cursor-pointer" />
        </a>
        <a
          href="https://x.com/SnappilyApp"
          target="_blank"
          rel="noopener noreferrer"
        >
          <RiTwitterXFill className="hover:text-white cursor-pointer" />
        </a>
        <a
          href="https://www.youtube.com/playlist?list=PLKaSTK-6738BLTKFop_rljSwtKPjO-V6R"
          target="_blank"
          rel="noopener noreferrer"
        >
          <SlSocialYoutube className="hover:text-white cursor-pointer" />
        </a>
        <a
          href="https://www.reddit.com/r/snappily"
          target="_blank"
          rel="noopener noreferrer"
        >
          <SlSocialReddit className="hover:text-white cursor-pointer" />
        </a>
      </div>
      <div className="w-screen text-sm text-center text-white bg-snappily-orange mt-20 px-10 pb-20">
        Copyright &copy; {dt.toFormat("yyyy")}. Snappily, Inc. All Rights
        Reserved.
      </div>
    </div>
  );
};

export default Footer;
